import $ from 'jquery';

const expandableContent = (el) => {
    const $el = $(el);
    const $content = $el.find('.js-expand-content');
    const $toggle = $el.find('.js-expand-toggle');

    if (!$toggle.length || !$content.length) {
        return;
    }

    const maxHeight = (parseInt($content.css('maxHeight'), 10) || 250);

    if ($content.prop('scrollHeight') <= (maxHeight + 30)) {
        $content.removeAttr('aria-hidden');
        $el.removeAttr('aria-expanded');
        $el.addClass('js-state-expand--not-expandable');
        return;
    }

    $el.addClass('js-state-expand--expandable');

    const duration = 300;

    $toggle.on('click', () => {
        const isExpanded = $el.hasClass('js-state-expand--expanded');
        $content.stop(true);

        if (isExpanded) {
            $el.removeClass('js-state-expand--expanded');
            $el.attr('aria-expanded', 'false');
            $content.attr('aria-hidden', 'true');
            $content.css('maxHeight', $content.prop('scrollHeight'));
            $content.animate({ maxHeight: maxHeight }, duration);
        } else {
            $el.addClass('js-state-expand--expanded');
            $el.attr('aria-expanded', 'true');
            $content.attr('aria-hidden', 'false');
            $content.animate(
                { maxHeight: $content.prop('scrollHeight') },
                duration,
                () => $content.css('maxHeight', '')
            );
        }
    });
};

export default expandableContent;
